const getShortenText = (text = '', length = 3): string => {
  if (text.length <= 3) return text;

  return `${text.substring(0, length)}`;
};

export default getShortenText;
